import React, { useState } from "react";
import { Row, Col } from "antd";
import { useLocation, Navigate } from "react-router-dom";
import TpvScoreBoard from "./TpvScoreBoard";
import usePDFExport from "../../../hooks/usePDFExport";
import Header from "../Header";

export default function PreviewTpvReport() {
  // Use the useLocation hook to access the location object
  const location = useLocation();
  const searchedParamLabels = {};
  const [redirect, setRedirect] = useState(false);
  // Access the state passed from the Link component
  const {
    searchedItem,
    NCScoreLoading,
    NCScoreTableData,
    NCLandLordScoreTableData,
    tpvList,
  } = location.state;
  const pdfPageIds = ["#tpvScoreBoard"];
  const { printDocument } = usePDFExport([], pdfPageIds, 'TPV Score Board.pdf');
  const goBack = () => {
    setRedirect(true);
  };
  const ndate = new Date().toJSON().slice(0, 10);
  const date =
    ndate.slice(8, 10) + "/" + ndate.slice(5, 7) + "/" + ndate.slice(0, 4);
  const NCScoreCellColor = {
    open_low: "rgb(165 205 20)",
    open_medium: "rgb(239 217 0)",
    open_high: "rgb(247 146 136)",
    close_low: "rgb(218, 239, 143)",
    close_medium: "rgb(255 239 91)",
    close_high: "rgb(255, 217, 213)",
    landlord_open: "rgb(90 203 227)",
    landlord_closed: "rgb(162 231 246)",
  };
  const LandlordStatsTableColCopy = [
    {
      key: "landlord_first_column",
      dataIndex: "landlord_first_column",
      width: 100,
    },
    {
      title: "Landlord",
      dataIndex: "land_lord",
      key: "land_lord",
      width: 100,
      render(text, record, index) {
        return {
          props: {
            style: {
              background:
                index == 1
                  ? NCScoreCellColor.landlord_closed
                  : NCScoreCellColor.landlord_open,
            },
          },
          children: (
            <div>
              {text}
              {index == 3 ? "%" : ""}
            </div>
          ),
        };
      },
    },
  ];
  const NCScoreTableColumnsCopy = [
    {
      key: "stats_first_column",
      dataIndex: "stats_first_column",
      width: 100,
    },
    {
      title: "High",
      width: 100,
      dataIndex: "alert_high",
      key: "alert_high",
      render(text, record, index) {
        return {
          props: {
            style: {
              background:
                index == 1
                  ? NCScoreCellColor.close_high
                  : NCScoreCellColor.open_high,
            },
          },
          children: (
            <div>
              {text}
              {index == 3 ? "%" : ""}
            </div>
          ),
        };
      },
    },
    {
      title: "Medium",
      width: 100,
      dataIndex: "alert_medium",
      key: "alert_medium",
      render(text, record, index) {
        return {
          props: {
            style: {
              background:
                index == 1
                  ? NCScoreCellColor.close_medium
                  : NCScoreCellColor.open_medium,
            },
          },
          children: (
            <div>
              {text}
              {index == 3 ? "%" : ""}
            </div>
          ),
        };
      },
    },
    {
      title: "Low",
      width: 100,
      dataIndex: "alert_low",
      key: "alert_low",
      render(text, record, index) {
        return {
          props: {
            style: {
              background:
                index == 1
                  ? NCScoreCellColor.close_low
                  : NCScoreCellColor.open_low,
            },
          },
          children: (
            <div>
              {text}
              {index == 3 ? "%" : ""}
            </div>
          ),
        };
      },
    },
  ];

  searchedParamLabels.AuditorName = tpvList?.AuditorList?.map((auditor) => {
    if (auditor.id == searchedItem.auditorId) return auditor.auditorName;
  })
    .flat()
    .filter((item) => item !== undefined);

  searchedParamLabels.StoreLabels = searchedItem?.storeId?.map(
    (searchedStore) => {
      const storeInfo = tpvList?.StoreList?.filter((store) => {
        return searchedStore == store.storeId;
      });
      return storeInfo[0]?.storeName;
    }
  );

  searchedParamLabels.StateLabels = searchedItem?.stateId?.map(
    (searchedState) => {
      const stateInfo = tpvList?.StateList?.filter((state) => {
        return searchedState == state.codeId;
      });
      return stateInfo[0]?.codeValue;
    }
  );

  searchedParamLabels.CityLabels = searchedItem?.cityId?.map((searchedCity) => {
    const cityInfo = tpvList?.CityList?.filter((city) => {
      return searchedCity == city.codeId;
    });
    return cityInfo[0]?.codeValue;
  });

  searchedParamLabels.ProjectScopesLabels = searchedItem?.projectScopeId?.map(
    (searchedProjectScope) => {
      const projectScopeInfo = tpvList?.ProjectScopes?.filter(
        (projectScope) => {
          return searchedProjectScope == projectScope.id;
        }
      );
      return projectScopeInfo[0]?.name;
    }
  );

  return (
    <div style={{ background: "white" }}>
      {redirect && (
    
        <Navigate to="/tpv" state={{ searchedItemFromPreview: searchedItem}} />
      )}
      <Header title="PDF Export" />
      <section>
        <div className="row" style={{ backgroundColor: "#fff" }}>
          <div className="col-md-12 mt-60 alignrow">
            <button
              type="button"
              className="btn btn-secondary deca-btn-orange"
              onClick={goBack}
              style={{
                cursor: "pointer",
                marginLeft: "107px",
              }}
            >
              <i className="fa fa-arrow-left" aria-hidden="true"></i>
            </button>
            <div>
              <button
                onClick={printDocument}
                className="deca-btn-yellow"
                style={{
                  marginRight: "10px",
                }}
              >
                Export to PDF
              </button>
            </div>
          </div>
        </div>
        <div
          id="tpvScoreBoard"
          className="mt4"
          style={{
            background: "white",
            width: "350mm",
            height: "90vh",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <div
            className="row"
            style={{ borderBottom: "0.5px black dotted", marginBottom: "20px" }}
          >
            <div className="col-md-2">
              <img
                alt="decalogo"
                src={require("./../PDFExport/logodecath.png")}
                style={{ padding: "10px" }}
                width="150"
                height="50"
              ></img>
            </div>
            <div className="col-md-10">
              <p
                style={{
                  textAlign: "right",
                  fontSize: "15px",
                  padding: "10px",
                }}
              >
                {"Third Party Audit" + " " + date}
              </p>
            </div>
          </div>
          <div className="p10">
            <Row gutter={16}>
              <Col span={5}>
                <div>
                  <label style={{ display: "inline" }}>Auditor:</label>
                  <span>
                    {" " +
                      (searchedParamLabels?.AuditorName[0] != undefined
                        ? searchedParamLabels?.AuditorName[0]
                        : "")}
                  </span>
                </div>
              </Col>
              <Col span={6}>
                <div>
                  <label style={{ display: "inline" }}>State:</label>
                  {searchedParamLabels?.StateLabels?.map((stateName, index) => {
                    return (
                      <span>
                        {" " +
                          stateName +
                          (searchedParamLabels?.StateLabels?.length !==
                          index + 1
                            ? ","
                            : "")}
                      </span>
                    );
                  })}
                </div>
              </Col>
              <Col span={6}>
                <div>
                  <label style={{ display: "inline" }}>City:</label>
                  {searchedParamLabels?.CityLabels?.map((cityName, index) => {
                    return (
                      <span>
                        {" " +
                          cityName +
                          (searchedParamLabels?.CityLabels?.length !== index + 1
                            ? ","
                            : "")}
                      </span>
                    );
                  })}
                </div>
              </Col>
              <Col span={6}>
                <div>
                  <label style={{ display: "inline" }}>Project Scopes:</label>
                  {searchedParamLabels?.ProjectScopesLabels?.map(
                    (projectScope, index) => {
                      return (
                        <span>
                          {" " +
                            projectScope +
                            (searchedParamLabels?.ProjectScopesLabels
                              ?.length !==
                            index + 1
                              ? ","
                              : "")}
                        </span>
                      );
                    }
                  )}
                </div>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={5}>
                <div style={{ padding: "2px" }}>
                  <label style={{ display: "inline" }}>Start Date:</label>
                  <span>
                    {" " +
                      (searchedItem?.startDate ? searchedItem?.startDate : "")}
                  </span>
                </div>
              </Col>
              <Col span={6}>
                <div>
                  <label style={{ display: "inline" }}>End Date:</label>
                  <span>
                    {" " + (searchedItem?.endDate ? searchedItem?.endDate : "")}
                  </span>
                </div>
              </Col>
              <Col span={10}>
                <div>
                  <label style={{ display: "inline" }}>Store:</label>
                  {searchedParamLabels?.StoreLabels?.map((storeName, index) => {
                    return (
                      <span>
                        {" " +
                          storeName +
                          (searchedParamLabels?.StoreLabels?.length !==
                          index + 1
                            ? ","
                            : "")}
                      </span>
                    );
                  })}
                </div>
              </Col>
            </Row>
          </div>
          <TpvScoreBoard
            NCScoreCellColor={NCScoreCellColor}
            NCScoreTableColumns={NCScoreTableColumnsCopy}
            NCScoreLoading={NCScoreLoading}
            NCScoreTableData={NCScoreTableData}
            LandlordStatsTableCol={LandlordStatsTableColCopy}
            NCLandLordScoreTableData={NCLandLordScoreTableData}
          />
        </div>
      </section>
    </div>
  );
}
